import { IonIcon } from '@ionic/react';
import Button from '../../../Button/Button';
import { FunctionalButtonConfig } from '../FunctionalButtonsRow';

interface FunctionalButtonProps {
  button: FunctionalButtonConfig;
}

const FunctionalButton = ({ button }: FunctionalButtonProps) => (
  <Button
    id={button.id}
    dataAttributes={{ 'data-functional-key': button.key }}
    onClick={button.onClick}
    disabled={button.disabled}
    fill="clear"
    round={false}
    className={button.className}
  >
    <IonIcon icon={button.icon} slot="start" />
    {button.label}
  </Button>
);

export default FunctionalButton;
